import updateCamera from 'reducers/updateCamera'
import batchUpdateCamera from 'reducers/batchUpdateCamera'
import updatePresentationValues from 'reducers/updatePresentationValues'
import addCamera from 'reducers/addCamera'
import removeCamera from 'reducers/removeCamera'
import setCameraToActive from 'reducers/setCameraToActive'
import addFloorPlan from 'reducers/addFloorPlan'
import removeFloorPlan from 'reducers/removeFloorPlan'
import updateFloorPlan from 'reducers/updateFloorPlan'
import applyProjects from 'reducers/applyProjects'
import partiallyApplyProjects from 'reducers/partiallyApplyProjects'
import expandProject from 'reducers/expandProject'
import addProject from 'reducers/addProject'
import removeProject from 'reducers/removeProject'
import addMessage from 'reducers/addMessage'
import clearMessage from 'reducers/clearMessage'
import updateUi from 'reducers/updateUi'
import addMapToState from 'reducers/addMapToState'
import updateMapLocation from 'reducers/updateMapLocation'
import updateUnit from 'reducers/updateUnit'
import updateMapZoom from 'reducers/updateMapZoom'
import addMapComponentReferences from 'reducers/addMapComponentReferences'
import updateProject from 'reducers/updateProject'
import updateMapType from 'reducers/updateMapType'
import addMarkup from 'reducers/addMarkup'
import updateMarkup from 'reducers/updateMarkup'
import deleteMarkup from 'reducers/deleteMarkup'
import setCurrentMarkup from 'reducers/setCurrentMarkup'
import floorPlanLoaded from 'reducers/floorPlanLoaded'
import clearModelReferences from 'reducers/clearModelReferences'
import updateCurrentEntity from 'reducers/updateCurrentEntity'
import lockProject from 'reducers/lockProject'
import removeLegacyProject from 'reducers/removeLegacyProject'
import duplicateCamera from 'reducers/duplicateCamera'
import favoriteModel from 'reducers/favoriteModel'
import unfavoriteModel from 'reducers/unfavoriteModel'
import applyCameraData from 'reducers/applyCameraData'
import addExportProgress from 'reducers/addExportProgress'
import updateExportProgress from 'reducers/updateExportProgress'
import destroyExportProgress from 'reducers/destroyExportProgress'
import removeManufacturerSpecificCameras from 'reducers/removeManufacturerSpecificCameras'
import removeManufacturerSpecific from 'reducers/removeManufacturerSpecific'
import clearCameras from 'reducers/clearCameras'
import addRecentModel from 'reducers/addRecentModel'
import addLensIds from 'reducers/addLensIds'
import addMultiImagerLens from 'reducers/addMultiImagerLens'
import duplicateLens from 'reducers/duplicateLens'
import removeMultiImager from 'reducers/removeMultiImager'
import clearMultiImagerLenses from 'reducers/clearMultiImagerLenses'
import updateUserSettings from 'reducers/updateUserSettings'
import addNetworkCloset from 'reducers/addNetworkCloset'
import deleteNetworkCloset from 'reducers/deleteNetworkCloset'
import addWiredDevice from 'reducers/addWiredDevice'
import deleteWiredDevice from 'reducers/deleteWiredDevice'
import duplicateWiredDevice from 'reducers/duplicateWiredDevice'
import addWire from 'reducers/addWire'
import deleteWire from 'reducers/deleteWire'
import removeDeviceWires from 'reducers/removeDeviceWires'
import addWireTooltipMapReference from 'reducers/addWireTooltipMapReference'
import addDoorController from 'reducers/addDoorController'
import deleteDoorController from 'reducers/deleteDoorController'
import addDoor from 'reducers/addDoor'
import deleteDoor from 'reducers/deleteDoor'
import addPeripheral from 'reducers/addPeripheral'
import deletePeripheral from 'reducers/deletePeripheral'
import addExpansionController from 'reducers/addExpansionController'
import changeDoorControllerModel from 'reducers/changeDoorControllerModel'
import updateEntity from 'reducers/updateEntity'
import { ADD_MARKUP, UPDATE_MARKUP, DELETE_MARKUP, SET_CURRENT_MARKUP } from 'actions/markupActions'
import { ADD_CAMERA, REMOVE_CAMERA, UPDATE_CAMERA, BATCH_UPDATE_CAMERA,
         SET_CAMERA_TO_ACTIVE, CLEAR_MODEL_REFERENCES, DUPLICATE_CAMERA,
         FAVORITE_MODEL, UNFAVORITE_MODEL, CLEAR_CAMERAS, ADD_RECENT_MODEL } from 'actions/cameraActions'
import { ADD_FLOOR_PLAN, REMOVE_FLOOR_PLAN, UPDATE_FLOOR_PLAN } from 'actions/floorPlanActionTypes'
import { UPDATE_PRESENTATION_VALUES } from 'actions/presentationActionTypes'
import { ADD_LENS_IDS, ADD_MULTI_IMAGER_LENS, DUPLICATE_MULTI_IMAGER_LENS,
         REMOVE_MULTI_IMAGER, CLEAR_MULTI_IMAGER_LENSES } from 'actions/multiImagerActionTypes'
import { APPLY_CAMERA_DATA, UPDATE_CURRENT_ENTITY, LOCK_PROJECT,
         REMOVE_CATCH_EARLY_FLAG, UPDATE_UPDATED_AT,
         REMOVE_MANUFACTURER_SPECIFIC_CAMERAS,
         UPDATE_SPECIFIC_MANUFACTURER, REMOVE_MANUFACTURER_SPECIFIC,
         ADD_DATABASE_CONFIG_INSTANCE, SHOW_MOBILE_START, HIDE_MOBILE_START,
         SHOW_MOBILE_ERROR, STORE_OFFLINE, STORE_ACTIVE } from 'actions/applicationActionTypes'
import { APPLY_PROJECTS, ADD_PROJECT, EXPAND_PROJECT, REMOVE_PROJECT,
         UPDATE_PROJECT, APPLY_LEGACY_PROJECTS,
         REMOVE_LEGACY_PROJECT, PARTIALLY_APPLY_PROJECTS, CLEAR_PROJECTS } from 'actions/projectActionTypes'
import { ADD_MESSAGE, CLEAR_MESSAGE } from 'actions/messageActionTypes'
import { ADD_NOTIFICATION, REMOVE_NOTIFICATION } from 'actions/notificationActionTypes'
import { UPDATE_UI, UPDATE_UNIT } from 'actions/uiActionTypes'
import { ADD_MAP_TO_STATE, UPDATE_MAP_LOCATION, UPDATE_MAP_ZOOM,
         ADD_MAP_COMPONENT_REFERENCES, UPDATE_MAP_TYPE } from 'actions/mapTypes'
import { FLOOR_PLAN_READY, UPDATE_EXPORT_TYPE, ADD_EXPORT_PROGRESS, UPDATE_EXPORT_PROGRESS,
         DESTROY_EXPORT_PROGRESS, FOV_PREVIEW_READY, CLEAR_FOV_PREVIEW_READY } from 'actions/exportActionTypes'
import { UPDATE_USER_SETTINGS } from 'actions/settingsActionTypes'
import { ADD_NETWORK_CLOSET, DELETE_NETWORK_CLOSET,
         ADD_WIRED_DEVICE, DELETE_WIRED_DEVICE, DUPLICATE_WIRED_DEVICE,
         ADD_WIRE, DELETE_WIRE, REMOVE_DEVICE_WIRES,
         ADD_WIRE_TOOLTIP_MAP_REFERENCE, UPDATE_ENTITY,
         ADD_DOOR_CONTROLLER, ADD_DOOR, ADD_PERIPHERAL,
         DELETE_DOOR_CONTROLLER, DELETE_DOOR, DELETE_PERIPHERAL,
         ADD_EXPANSION_CONTROLLER, CHANGE_DOOR_CONTROLLER_MODEL } from 'actions/entityActionTypes'
import updateSingleValue from 'helpers/updateSingleValue'

export default function app(state = { catchEarlyErrors: true }, action) {
  switch (action.type) {
    // Cameras
    case ADD_CAMERA:
      return addCamera(state, action)
    case REMOVE_CAMERA:
      return removeCamera(state, action)
    case UPDATE_CAMERA:
      return updateCamera(state, action)
    case BATCH_UPDATE_CAMERA:
      return batchUpdateCamera(state, action)
    case SET_CAMERA_TO_ACTIVE:
      return setCameraToActive(state, action)
    case CLEAR_MODEL_REFERENCES:
      return clearModelReferences(state, action)
    case DUPLICATE_CAMERA:
      return duplicateCamera(state, action)
    case FAVORITE_MODEL:
      return favoriteModel(state, action)
    case UNFAVORITE_MODEL:
      return unfavoriteModel(state, action)
    case CLEAR_CAMERAS:
      return clearCameras(state, action)
    case ADD_RECENT_MODEL:
      return addRecentModel(state, action)
    // Presentation interface
    case UPDATE_PRESENTATION_VALUES:
      return updatePresentationValues(state, action)
    // Multi-Imagers
    case ADD_LENS_IDS:
      return addLensIds(state, action)
    case ADD_MULTI_IMAGER_LENS:
      return addMultiImagerLens(state, action)
    case DUPLICATE_MULTI_IMAGER_LENS:
      return duplicateLens(state, action)
    case REMOVE_MULTI_IMAGER:
      return removeMultiImager(state, action)
    case CLEAR_MULTI_IMAGER_LENSES:
      return clearMultiImagerLenses(state, action)
    // Floor Plans
    case ADD_FLOOR_PLAN:
      return addFloorPlan(state, action)
    case REMOVE_FLOOR_PLAN:
      return removeFloorPlan(state, action)
    case UPDATE_FLOOR_PLAN:
      return updateFloorPlan(state, action)
    // Messages
    case ADD_MESSAGE:
      return addMessage(state, action)
    case CLEAR_MESSAGE:
      return clearMessage(state, action)
    // Notifications
    case ADD_NOTIFICATION:
      return updateSingleValue('notification')(state, Object.assign({}, { message: action.message, type: action.notificationType }))
    case REMOVE_NOTIFICATION:
      return updateSingleValue('notification')(state, null)
    // Projects
    case APPLY_PROJECTS:
      return applyProjects(state, action)
    case PARTIALLY_APPLY_PROJECTS:
      return partiallyApplyProjects(state, action)
    case APPLY_LEGACY_PROJECTS:
      return updateSingleValue('legacyProjects')(state, action.projects)
    case EXPAND_PROJECT:
      return expandProject(state, action)
    case ADD_PROJECT:
      return addProject(state, action)
    case REMOVE_PROJECT:
      return removeProject(state, action)
    case UPDATE_PROJECT:
      return updateProject(state, action)
    case LOCK_PROJECT:
      return lockProject(state, action)
    case REMOVE_LEGACY_PROJECT:
      return removeLegacyProject(state, action)
    case CLEAR_PROJECTS:
      return updateSingleValue('projects')(state, [])
    // UI
    case UPDATE_UI:
      return updateUi(state, action)
    case UPDATE_UNIT:
      return updateUnit(state, action)
    // SETTINGS
    case UPDATE_USER_SETTINGS:
      return updateUserSettings(state, action)
    // MAP
    case ADD_MAP_TO_STATE:
      return addMapToState(state, action)
    case UPDATE_MAP_LOCATION:
      return updateMapLocation(state, action)
    case UPDATE_MAP_ZOOM:
      return updateMapZoom(state, action)
    case ADD_MAP_COMPONENT_REFERENCES:
      return addMapComponentReferences(state, action)
    case UPDATE_MAP_TYPE:
      return updateMapType(state, action)
    // CAMERA MODELS
    case APPLY_CAMERA_DATA:
      return applyCameraData(state, action)
    case REMOVE_MANUFACTURER_SPECIFIC_CAMERAS:
      return removeManufacturerSpecificCameras(state, action)
    // MARKUPS
    case ADD_MARKUP:
      return addMarkup(state, action)
    case UPDATE_MARKUP:
      return updateMarkup(state, action)
    case DELETE_MARKUP:
      return deleteMarkup(state, action)
    case SET_CURRENT_MARKUP:
      return setCurrentMarkup(state, action)
    // CURRENT ENTITY
    case UPDATE_CURRENT_ENTITY:
      return updateCurrentEntity(state, action)
    // EXPORTS
    case FLOOR_PLAN_READY:
      return floorPlanLoaded(state, action)
    case UPDATE_EXPORT_TYPE:
      return updateSingleValue('exportType')(state, action.exportType)
    case UPDATE_EXPORT_PROGRESS:
      return updateExportProgress(state, action)
    case ADD_EXPORT_PROGRESS:
      return addExportProgress(state, action)
    case DESTROY_EXPORT_PROGRESS:
      return destroyExportProgress(state, action)
    // ENTITIES:
    case ADD_NETWORK_CLOSET:
      return addNetworkCloset(state, action)
    case DELETE_NETWORK_CLOSET:
      return deleteNetworkCloset(state, action)
    case ADD_WIRED_DEVICE:
      return addWiredDevice(state, action)
    case DELETE_WIRED_DEVICE:
      return deleteWiredDevice(state, action)
    case DUPLICATE_WIRED_DEVICE:
      return duplicateWiredDevice(state, action)
    case ADD_WIRE:
      return addWire(state, action)
    case DELETE_WIRE:
      return deleteWire(state, action)
    case REMOVE_DEVICE_WIRES:
      return removeDeviceWires(state, action)
    case ADD_WIRE_TOOLTIP_MAP_REFERENCE:
      return addWireTooltipMapReference(state, action)
    case ADD_DOOR_CONTROLLER:
      return addDoorController(state, action)
    case DELETE_DOOR_CONTROLLER:
      return deleteDoorController(state, action)
    case ADD_DOOR:
      return addDoor(state, action)
    case DELETE_DOOR:
      return deleteDoor(state, action)
    case ADD_PERIPHERAL:
      return addPeripheral(state, action)
    case DELETE_PERIPHERAL:
      return deletePeripheral(state, action)
    case ADD_EXPANSION_CONTROLLER:
      return addExpansionController(state, action)
    case CHANGE_DOOR_CONTROLLER_MODEL:
      return changeDoorControllerModel(state, action)
    case UPDATE_ENTITY:
      return updateEntity(state, action)
    // MISC
    case REMOVE_CATCH_EARLY_FLAG:
      return updateSingleValue('catchEarlyErrors')(state, false)
    case UPDATE_UPDATED_AT:
      return updateSingleValue('updatedAt')(state, action.updatedAt)
    case UPDATE_SPECIFIC_MANUFACTURER:
      return updateSingleValue('specificManufacturer')(state, action.specificManufacturer)
    case REMOVE_MANUFACTURER_SPECIFIC:
      return removeManufacturerSpecific(state, action)
    case ADD_DATABASE_CONFIG_INSTANCE:
      return updateSingleValue('database')(state, action.database)
    case FOV_PREVIEW_READY:
      return updateSingleValue('fovReady')(state, true)
    case CLEAR_FOV_PREVIEW_READY:
      return updateSingleValue('fovReady')(state, false)
    case SHOW_MOBILE_START:
      return updateSingleValue('showMobileStart')(state, true)
    case HIDE_MOBILE_START:
      return updateSingleValue('showMobileStart')(state, false)
    case SHOW_MOBILE_ERROR:
      return updateSingleValue('mobileError')(state, true)
    case STORE_OFFLINE:
      return updateSingleValue('offline')(state, action.offline)
    case STORE_ACTIVE:
      return updateSingleValue('active')(state, action.active)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/index.js